/**
 * Shared design tokens / theme
 */

export const colors = {
  /** Primary accent – bright yellow */
  primary: '#daff00',
  /** Muted/disabled yellow background */
  primaryDisabledBg: '#3a3a20',
  /** Muted/disabled yellow border */
  primaryDisabledBorder: '#5a5a30',
  /** Muted/disabled yellow foreground (text / icon) */
  primaryDisabledFg: '#7a7a50',

  /** Dark surface */
  surface: '#2a2a2a',
  surfaceDark: '#1e1e1e',

  /** Borders */
  borderDefault: '#333',
  borderMuted: '#555',
  borderHover: '#888',

  /** Text */
  textPrimary: '#fff',
  textMuted: '#aaa',
  textDisabled: '#555',

  /** Semantic */
  error: '#ff5555',
} as const;

export const radii = {
  sm: '6px',
  md: '8px',
  lg: '12px',
} as const;

export const transitions = {
  fast: '0.15s ease',
  normal: '0.2s ease',
} as const;
